/** Tiny synchronous event emitter for decoupled cross-system messaging. */
export class Signal<T = void> {
  private handlers = new Set<(payload: T) => void>();

  on(handler: (payload: T) => void): () => void {
    this.handlers.add(handler);
    return () => this.handlers.delete(handler);
  }

  emit(payload: T): void {
    for (const h of this.handlers) h(payload);
  }

  clear(): void {
    this.handlers.clear();
  }
}
